const INVENTORY_PREFERENCES_PATH = ['preferences', 'back_office', 'inventory'];

export const STATE_KEYS = {
  STARTING_COUNT_OVERRIDE: [
    ...INVENTORY_PREFERENCES_PATH,
    'starting_count_override',
  ],
  PRIMARY_WAREHOUSE: [
    'preferences',
    'back_office',
    'warehouse',
    'primary_warehouse',
  ],
  QUANTITY_PRECISION: [...INVENTORY_PREFERENCES_PATH, 'quantity_precision'],
  ITEM_COUNT_SIGN_IN_METHOD: [
    ...INVENTORY_PREFERENCES_PATH,
    'item_count_sign_in_method',
  ],
  XDM_THOUSANDS_SEPARATOR: [
    'preferences',
    'regional_settings',
    'thousands_separator',
  ],
  XDM_PRECISION: ['preferences', 'regional_settings', 'precision'],
  XDM_DECIMAL_SEPARATOR: [
    'preferences',
    'regional_settings',
    'decimal_separator',
  ],
  XDM_NEGATIVES: ['preferences', 'regional_settings', 'negatives'],
  XDM_CROWDIN_CUSTOM: ['preferences', 'crowdin_custom_language'],
};
